module.exports = __webpack_public_path__ + "img/42.c1f45c53.jpg";